/**
 * 첫 사용자 메시지로 대화 제목을 자동 생성할지 결정한다.
 *
 * 일반/통합 에이전트는 기존처럼 첫 메시지를 제목으로 쓴다. 아래 네임스페이스를
 * 실어 보내는 워크스페이스는 제목이 이미 문서를 가리키고 있으므로
 * (`doc-agent` 는 파일명, `gtc-agent` 는 비교한 두 판본, `purchase-agent` 는
 * 선적서류 번들 파일명) 덮어쓰지 않는다 —
 * `allow_title_autogen: true` 를 명시한 경우에만 허용한다.
 */
const DOCUMENT_OWNED_TITLE_NAMESPACES = ['doc_agent', 'gtc_agent', 'purchase_agent'] as const;

export function isFirstMessageTitleAutogenEnabled(
  requestMetadata: Record<string, unknown> | null | undefined,
): boolean {
  if (!requestMetadata || typeof requestMetadata !== 'object') return true;

  for (const namespace of DOCUMENT_OWNED_TITLE_NAMESPACES) {
    const scoped = requestMetadata[namespace];
    if (!scoped || typeof scoped !== 'object') continue;
    if ((scoped as Record<string, unknown>).allow_title_autogen !== true) {
      return false;
    }
  }

  return true;
}
